export default "__VITE_ASSET__2a4c40da__"